// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_updateUserNotificationPreferenceV5(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["UserNotificationPreferenceWasUpdated"]);
}

let variablesConverter = {"areaV5Input":{},"developmentNotificationPreferenceInput":{"areaGroup":{"r":"areaGroupV5Input"}},"propertyNotificationPreferenceInput":{"areaGroup":{"r":"areaGroupV5Input"}},"userAreaGroupInput":{"areas":{"r":"areaV5Input"}},"clientNeedNotificationPreferenceV5Input":{"areaGroup":{"r":"areaGroupV5Input"}},"areaGroupV5Input":{"userAreaGroup":{"r":"userAreaGroupInput"},"newUserAreaGroup":{"r":"newUserAreaGroupInput"}},"newUserAreaGroupInput":{"areas":{"r":"areaV5Input"}},"notificationPreferenceV5Input":{"rentalProperty":{"r":"propertyNotificationPreferenceInput"},"rentalNeeds":{"r":"clientNeedNotificationPreferenceV5Input"},"property":{"r":"propertyNotificationPreferenceInput"},"developments":{"r":"developmentNotificationPreferenceInput"},"buyerNeeds":{"r":"clientNeedNotificationPreferenceV5Input"}},"__root":{"input":{"r":"notificationPreferenceV5Input"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"updateUserNotificationPreferenceV5_UserNotificationPreferenceWasUpdated_updatedUserNotificationSettings":{"f":""},"updateUserNotificationPreferenceV5":{"u":"response_updateUserNotificationPreferenceV5"}}};

let wrapResponseConverterMap = {
  response_updateUserNotificationPreferenceV5: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"updateUserNotificationPreferenceV5_UserNotificationPreferenceWasUpdated_updatedUserNotificationSettings":{"f":""},"updateUserNotificationPreferenceV5":{"u":"response_updateUserNotificationPreferenceV5"}}};

let responseConverterMap = {
  response_updateUserNotificationPreferenceV5: unwrap_response_updateUserNotificationPreferenceV5
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function forSalePropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY" || $$enum === "LOT" || $$enum === "MULTI_UNIT") {
    return $$enum;
  }
}

let forSalePropertyTypeEnumV5_fromString = forSalePropertyTypeEnumV5_decode;

function propertyNotificationPreferenceMLSStatus_decode($$enum) {
  if ($$enum === "ANY" || $$enum === "NOT_ACTIVE_ON_MLS") {
    return $$enum;
  }
}

let propertyNotificationPreferenceMLSStatus_fromString = propertyNotificationPreferenceMLSStatus_decode;

let Utils = {
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: forSalePropertyTypeEnumV5_fromString,
  propertyNotificationPreferenceMLSStatus_decode: propertyNotificationPreferenceMLSStatus_decode,
  propertyNotificationPreferenceMLSStatus_fromString: propertyNotificationPreferenceMLSStatus_fromString
};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usedFor",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v6 = {
  "alias": "type_",
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "userHasInactiveCustomPreference",
    "storageKey": null
  }
],
v9 = {
  "kind": "InlineFragment",
  "selections": (v8/*: any*/),
  "type": "ChapterDefaultNotificationSetting",
  "abstractKey": null
},
v10 = {
  "kind": "InlineFragment",
  "selections": (v8/*: any*/),
  "type": "MatchesOnlyNotificationSetting",
  "abstractKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxPrice",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minPrice",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "propertyTypes",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "Area",
  "kind": "LinkedField",
  "name": "areas",
  "plural": true,
  "selections": [
    (v6/*: any*/)
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "areaGroup",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isAreaGroupV5"
    },
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Area",
      "kind": "LinkedField",
      "name": "areas",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        (v5/*: any*/),
        (v7/*: any*/)
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v4/*: any*/),
        (v14/*: any*/)
      ],
      "type": "UserAreaGroup",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v14/*: any*/)
      ],
      "type": "ChapterAreaGroup",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v16 = [
  (v2/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v11/*: any*/),
      (v12/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mlsStatus",
        "storageKey": null
      },
      (v13/*: any*/),
      (v15/*: any*/)
    ],
    "type": "CustomPropertyNotificationPreference",
    "abstractKey": null
  }
],
v17 = [
  (v2/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v15/*: any*/)
    ],
    "type": "CustomClientNeedNotificationPreference",
    "abstractKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateUserNotificationPreferenceV5",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNotificationSettingsV5",
                "kind": "LinkedField",
                "name": "updatedUserNotificationSettings",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "NotificationSettings_userNotificationSettings"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "UserNotificationPreferenceWasUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateUserNotificationPreferenceV5",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNotificationSettingsV5",
                "kind": "LinkedField",
                "name": "updatedUserNotificationSettings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserAreaGroup",
                    "kind": "LinkedField",
                    "name": "userAreaGroups",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Area",
                        "kind": "LinkedField",
                        "name": "areas",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "forSaleProperties",
                    "plural": false,
                    "selections": (v16/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "rentalProperties",
                    "plural": false,
                    "selections": (v16/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "buyerNeeds",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "rentalNeeds",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BroadcastMessageNotificationSettingV5",
                    "kind": "LinkedField",
                    "name": "broadcastMessages",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "setting",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "UserNotificationPreferenceWasUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ff25781a38759a6b67fcf24c341de43a",
    "id": null,
    "metadata": {},
    "name": "NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation",
    "operationKind": "mutation",
    "text": "mutation NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation(\n  $input: NotificationPreferenceV5Input!\n) {\n  updateUserNotificationPreferenceV5(input: $input) {\n    __typename\n    ... on UserNotificationPreferenceWasUpdated {\n      updatedUserNotificationSettings {\n        ...NotificationSettings_userNotificationSettings\n        nodeId\n      }\n    }\n  }\n}\n\nfragment NotificationSettingsBroadcastMessages_notificationSetting on UserNotificationSettingsV5 {\n  nodeId\n  broadcastMessages {\n    setting\n  }\n}\n\nfragment NotificationSettingsBuyerNeeds_notificationSetting on UserNotificationSettingsV5 {\n  ...NotificationSettingsPreferenceEditDialog_settings\n  buyerNeeds {\n    __typename\n    ... on ChapterDefaultNotificationSetting {\n      userHasInactiveCustomPreference\n    }\n    ... on MatchesOnlyNotificationSetting {\n      userHasInactiveCustomPreference\n    }\n    ... on CustomClientNeedNotificationPreference {\n      maxPrice\n      minPrice\n      propertyTypes\n      areaGroup {\n        __typename\n        ...NotificationSettingsComponents_group\n      }\n      ...NotificationSettingsPreferenceEditDialog_clientNeed\n    }\n  }\n}\n\nfragment NotificationSettingsComponents_byType on AreaGroupV5 {\n  __isAreaGroupV5: __typename\n  __typename\n  ... on UserAreaGroup {\n    __typename\n  }\n  ... on ChapterAreaGroup {\n    __typename\n  }\n}\n\nfragment NotificationSettingsComponents_group on AreaGroupV5 {\n  __isAreaGroupV5: __typename\n  __typename\n  id\n  areas {\n    id\n    label\n    nodeId\n  }\n  ... on UserAreaGroup {\n    usedFor\n  }\n  ...NotificationSettingsComponents_byType\n}\n\nfragment NotificationSettingsForSaleProperties_notificationSetting on UserNotificationSettingsV5 {\n  ...NotificationSettingsPreferenceEditDialog_settings\n  forSaleProperties {\n    __typename\n    ... on ChapterDefaultNotificationSetting {\n      userHasInactiveCustomPreference\n    }\n    ... on MatchesOnlyNotificationSetting {\n      userHasInactiveCustomPreference\n    }\n    ... on CustomPropertyNotificationPreference {\n      maxPrice\n      minPrice\n      mlsStatus\n      propertyTypes\n      areaGroup {\n        __typename\n        ...NotificationSettingsComponents_group\n      }\n      ...NotificationSettingsPreferenceEditDialog_preference\n    }\n  }\n}\n\nfragment NotificationSettingsPreferenceEditDialogAreaGroups_settings on UserNotificationSettingsV5 {\n  userAreaGroups {\n    id\n    usedFor\n    areas {\n      id\n      label\n      type_: type\n      nodeId\n    }\n  }\n}\n\nfragment NotificationSettingsPreferenceEditDialog_areaGroup on AreaGroupV5 {\n  __isAreaGroupV5: __typename\n  __typename\n  ... on ChapterAreaGroup {\n    id\n    areas {\n      label\n      id\n      type_: type\n      nodeId\n    }\n  }\n  ... on UserAreaGroup {\n    id\n    areas {\n      id\n      label\n      type_: type\n      nodeId\n    }\n    usedFor\n  }\n}\n\nfragment NotificationSettingsPreferenceEditDialog_clientNeed on CustomClientNeedNotificationPreference {\n  maxPrice\n  minPrice\n  propertyTypes\n  areaGroup {\n    __typename\n    ...NotificationSettingsPreferenceEditDialog_areaGroup\n  }\n}\n\nfragment NotificationSettingsPreferenceEditDialog_preference on CustomPropertyNotificationPreference {\n  maxPrice\n  minPrice\n  mlsStatus\n  propertyTypes\n  areaGroup {\n    __typename\n    ...NotificationSettingsPreferenceEditDialog_areaGroup\n  }\n}\n\nfragment NotificationSettingsPreferenceEditDialog_settings on UserNotificationSettingsV5 {\n  ...NotificationSettingsPreferenceEditDialogAreaGroups_settings\n}\n\nfragment NotificationSettingsRentalNeeds_notificationSetting on UserNotificationSettingsV5 {\n  ...NotificationSettingsPreferenceEditDialog_settings\n  rentalNeeds {\n    __typename\n    ... on ChapterDefaultNotificationSetting {\n      userHasInactiveCustomPreference\n    }\n    ... on MatchesOnlyNotificationSetting {\n      userHasInactiveCustomPreference\n    }\n    ... on CustomClientNeedNotificationPreference {\n      maxPrice\n      minPrice\n      propertyTypes\n      areaGroup {\n        __typename\n        ...NotificationSettingsComponents_group\n      }\n      ...NotificationSettingsPreferenceEditDialog_clientNeed\n    }\n  }\n}\n\nfragment NotificationSettingsRentalProperties_notificationSetting on UserNotificationSettingsV5 {\n  ...NotificationSettingsPreferenceEditDialog_settings\n  rentalProperties {\n    __typename\n    ... on ChapterDefaultNotificationSetting {\n      userHasInactiveCustomPreference\n    }\n    ... on MatchesOnlyNotificationSetting {\n      userHasInactiveCustomPreference\n    }\n    ... on CustomPropertyNotificationPreference {\n      maxPrice\n      minPrice\n      mlsStatus\n      propertyTypes\n      areaGroup {\n        __typename\n        ...NotificationSettingsComponents_group\n      }\n      ...NotificationSettingsPreferenceEditDialog_preference\n    }\n  }\n}\n\nfragment NotificationSettings_userNotificationSettings on UserNotificationSettingsV5 {\n  ...NotificationSettingsForSaleProperties_notificationSetting\n  ...NotificationSettingsRentalProperties_notificationSetting\n  ...NotificationSettingsBuyerNeeds_notificationSetting\n  ...NotificationSettingsRentalNeeds_notificationSetting\n  ...NotificationSettingsBroadcastMessages_notificationSetting\n}\n"
  }
};
})());

let wrap_response_updateUserNotificationPreferenceV5 = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_updateUserNotificationPreferenceV5 = unwrap_response_updateUserNotificationPreferenceV5;
exports.wrap_response_updateUserNotificationPreferenceV5 = wrap_response_updateUserNotificationPreferenceV5;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
